export const modalDelayMs = 3000;
export const APPLICATION_QUESTIONS = {
  NAME: "Application Name",
  DESCRIPTION: "Application Description",
  WEBSITE: "Application Website",
  LOGO: "Application Logo",
  BANNER: "Application Banner"
};